import axios from 'axios';
import { getStorage } from 'src/utils/utils';

const testOnly = 'https://api.jspay.me';

const ENDPOINT = {
	STAFF: {
		SIGN_IN: `${testOnly}/auth/login`,
		CHANGE_PASSWORD: `${testOnly}/user/change-password`,
		OPEN_2FA: `${testOnly}/user/generate/turn-on`,
		CLOSE_2FA: `${testOnly}/user/generate/turn-off`,
	},
};

export const StaffService = {
	signIn: (data) => {
		return axios({
			method: 'POST',
			url: ENDPOINT.STAFF.SIGN_IN,
			data,
		});
	},
	changePassword: (data) => {
		return axios({
			method: 'POST',
			url: ENDPOINT.STAFF.CHANGE_PASSWORD,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
			data,
		});
	},

	open2FaByUserId: (data) => {
		return axios({
			method: 'POST',
			url: ENDPOINT.STAFF.OPEN_2FA,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
			data,
		});
	},

	close2FaByUserId: (data) => {
		return axios({
			method: 'POST',
			url: ENDPOINT.STAFF.CLOSE_2FA,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
			data,
		});
	},
};
